module.exports = __webpack_public_path__ + "media/win-chips.13671865.mp3";